import React, { Component } from "react";
import { TabPane, Grid, Divider } from "semantic-ui-react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import ThemeSelection from "./ThemeSelection";
import { themeChanged } from "../../actions/settings";

/**
 * AppearancePane : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Settings tab pane containing Appearance controls,
 * such as theme selection.
 */
class AppearancePane extends Component {
  /**
   * onThemeSelected: (event, sender) => ()
   * Fired when the selected theme from the dropdown has changed.
   */
  onThemeSelected = (_, { value }) => {
    this.props.themeChanged(value);
  };

  /**
   * Renders the settings pane.
   */
  render() {
    return (
      <TabPane>
        <h3>
          <FormattedMessage
            id="settings.appearance.title"
            description="Category title for Appearance settings pane"
          />
        </h3>
        <Divider />
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <b>
                <FormattedMessage
                  id="settings.appearance.theme.title"
                  description="Title for theme section"
                />
              </b>
            </Grid.Column>
            <Grid.Column width={8}>
              <ThemeSelection
                onChange={this.onThemeSelected}
                currentTheme={this.props.theme}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <p>
                <FormattedMessage
                  id="settings.appearance.theme.description"
                  description="Description for settings theme section"
                />
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TabPane>
    );
  }
}

const mapStateToProps = state => ({
  theme: state.settings.theme || "dark"
});

AppearancePane.propTypes = {
  /**
   * theme: String
   * Currently selected theme identifier
   */
  theme: PropTypes.string.isRequired,
  /**
   * themeChanged: newTheme => ()
   * Function to dispatch theme change via Redux
   */
  themeChanged: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  { themeChanged }
)(AppearancePane);



// WEBPACK FOOTER //
// ./src/modules/settings/AppearancePane.js